export function numberWithinRangeInclusive(
  value: number,
  between: { min: number; max: number },
) {
  if (value < between.min) return between.min;
  if (value > between.max) return between.max;

  return value;
}
